import getConfig from "next/config";

const {
  publicRuntimeConfig: {
    settings: { websiteName },
  },
} = getConfig();

const CarouselNavArrow = ({ direction }) => {
  const rotation = {
    up: "rotate-90",
    down: "-rotate-90",
    left: "",
    right: "-rotate-180",
  }[direction];

  return websiteName === "bricostore" ? (
    // Material Design "chevron_left" (24x24, Apache-2.0) — base points left like the original. Color via fill-current.
    <svg
      className={`transform fill-current ${rotation}`}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59Z" />
    </svg>
  ) : (
    <svg
      className={`transform ${rotation}`}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 14L17.334 19.1158C16.8887 19.604 16.8887 20.396 17.334 20.8842L22 26"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CarouselNavArrow;
